// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../../library/NetworkUtils.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DummyQuotationData from "./dummy_resposes/DummyQuotationData.bs.js";
import * as DummyLocationBounds from "./dummy_resposes/DummyLocationBounds.bs.js";
import * as DummyVehicleDetails from "./dummy_resposes/DummyVehicleDetails.bs.js";
import * as PlaceOrderRepoConfig from "./PlaceOrderRepoConfig.bs.js";
import * as DummyRestrictionBounds from "./dummy_resposes/DummyRestrictionBounds.bs.js";
import * as DummyCouponsListResponse from "./dummy_resposes/DummyCouponsListResponse.bs.js";

var dummyPlceOrderResponse = {
    "order_crn":"44444"
  };

function fetchLocationBounds(geo_region_id, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: DummyLocationBounds.value
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.LocationBoundsResponseConverter.execute, result);
                            });
                }), "fetchLocationBounds");
}

function fetchRestrictionBounds(geo_region_id, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: DummyRestrictionBounds.value
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.RestrictionBoundsResponseConverter.execute, result);
                            });
                }), "fetchRestrictionBounds");
}

function fetchVehicleDetails(geo_region_id, latLng, mobile, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: DummyVehicleDetails.value
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.VehicleDetailsResponseConverter.execute, result);
                            });
                }), "fetchVehicleDetails");
}

function fetchVehicleQuotation(payload, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: DummyQuotationData.value
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.VehicleQuotationsResponseConverter.execute, result);
                            });
                }), "fetchVehicleQuotation");
}

function fetchCouponList(geo_region_id, pickupLatLng, dropLatLng, customer_id, country, order_id) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: DummyCouponsListResponse.value
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.CouponListResponseConverter.execute, result);
                            });
                }), "fetchCouponList");
}

function placeOrder(payload, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyPlceOrderResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.PlaceOrderResponseConverter.execute, result);
                            });
                }), "placeOrder");
}

function applyCoupon(payload, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: DummyQuotationData.value
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.VehicleQuotationsResponseConverter.execute, result);
                            });
                }), "fetchVehicleQuotation");
}

function removeCoupon(payload, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: DummyQuotationData.value
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PlaceOrderRepoConfig.VehicleQuotationsResponseConverter.execute, result);
                            });
                }), "fetchVehicleQuotation");
}

var PlaceOrderRepo = {
  fetchLocationBounds: fetchLocationBounds,
  fetchRestrictionBounds: fetchRestrictionBounds,
  fetchVehicleDetails: fetchVehicleDetails,
  fetchVehicleQuotation: fetchVehicleQuotation,
  fetchCouponList: fetchCouponList,
  placeOrder: placeOrder,
  applyCoupon: applyCoupon,
  removeCoupon: removeCoupon
};

export {
  PlaceOrderRepo ,
  
}
/* NetworkUtils Not a pure module */
